import { CustomChip } from "../../../components/chip/Chip";
import { colorEstadoChip } from "../constants/colorEstados";

const columnsBase = [
    {
        field: 'idVisita',
        headerName: '#',
        flex: 0.6,
        width: 40,
    },
    {
        field: 'forma',
        headerName: 'Modalidad',
        flex: 1,
        width: 100,
    },
    {
        field: 'tipo',
        headerName: 'Tipo',
        flex: 1,
        width: 80,
    },
    {
        field: 'codigoAtencion',
        headerName: 'Caso',
        flex: 1,
        width: 80,
    },
    {
        field: 'horaIngreso',
        headerName: 'Fecha ingreso',
        flex: 1.3,
        width: 160,
    },
    {
        field: 'horaEgreso',
        headerName: 'Fecha egreso',
        flex: 1.3,
        width: 160,
    },
    {
        field: 'tiempoTotal',
        headerName: 'Tiempo total',
        flex: 1.2,
        width: 100,
    },
    {
        field: 'modificada',
        headerName: 'Modificada',
        flex: 1,
        width: 100,
    },
    {
        field: 'usuarioModificador',
        headerName: 'Usuario modificador',
        flex: 2,
        width: 200,
    },
    {
        field: 'idFase',
        headerName: 'Fase',
        flex: 2,
        width: 100,
        renderCell: ({ row }) => {
            return (
                row?.idFase ?? '-'
            )
        }
    },
    {
        field: 'estadoLiquidacion',
        headerName: 'Estado Liquidación',
        flex: 2,
        width: 160,
        renderCell: ({ row }) => {
            const color = colorEstadoChip[row.estado];
            return (
                <CustomChip {...color} label={row.estado} />
            )
        }
    },
];

export default columnsBase;